import { DrawerProps } from '@mui/material';
import { useEffect, useState, useCallback } from 'react';

import NewMessage from '../../screens/NewMessage';

import Navigator from 'modules/common/components/Navigator';
import RightDrawer from 'modules/common/components/RightDrawer/Drawer';
import Home from 'modules/IMC/MessageCenter/screens/Home';
import Chat from 'modules/IMC/MessageCenter/screens/Chat';
import { useIMCContext } from 'modules/IMC/common/context';
import useMessageCenterCopy from 'modules/IMC/common/hooks/useMessageCenterCopy';
import { DrawerTypes } from 'modules/IMC/common/context/IMCContext.interface';
import {
    MessageCenterScreen,
    NavigationUpdateContextType,
} from 'modules/common/components/Navigator/context/NavigatorContext.interface';

export default function MessageCenter({ drawerProps = {} }: { drawerProps?: DrawerProps }) {
    const { currOpenDrawer, messageCenterNavigationRef, initialTicketId } = useIMCContext();
    const { drawerTitle } = useMessageCenterCopy();
    const [ticketId, setTicketId] = useState<number | null>(initialTicketId);
    const [navigationApi, setNavigationApi] = useState<NavigationUpdateContextType | null>(null);

    const navigationRef = useCallback(
        (ref: NavigationUpdateContextType | null) => {
            if (ref) {
                setNavigationApi(ref);
                messageCenterNavigationRef.current = ref;
            }
        },
        [messageCenterNavigationRef]
    );

    useEffect(() => {
        if (messageCenterNavigationRef?.current) {
            setNavigationApi(messageCenterNavigationRef.current);
        }
    }, [currOpenDrawer, messageCenterNavigationRef]);

    useEffect(() => {
        if (ticketId && navigationApi) {
            navigationApi.navigateToPage(MessageCenterScreen.CHAT, { id: ticketId });
            setTicketId(null);
        }
    }, [ticketId, navigationApi]);

    return (
        <RightDrawer ariaLabel={drawerTitle} open={currOpenDrawer === DrawerTypes.MESSAGE_CENTER} {...drawerProps}>
            <Navigator ref={navigationRef}>
                <Navigator.Screen name="home" component={Home} />
                <Navigator.Screen name="newMessage" component={NewMessage} />
                <Navigator.Screen name="chat" component={Chat} />
            </Navigator>
        </RightDrawer>
    );
}
